<mat-card>
  <mat-card-content fxLayout="column">
    <p8-disclaimer-test></p8-disclaimer-test>
  </mat-card-content>
  <app-candidatures></app-candidatures>
</mat-card>


